export default __webpack_public_path__ + "static/media/Logo_EN.bf0757d9.png";